import React, { useState, useEffect } from "react";
import StockSummary from "../../components/layout/stock/StockSummary";
import NewsList from "../../components/common/NewsList";
import {
  getIndustryNThemeNewsAPI,
  getRealtimeNewsAPI,
  getStockDataAPI,
  getStockcode,
  getStockcode2,
} from "../../apis/news_service";
import Loading from "../error/Loading";
import NineMemosReports from "../stock/ninememosReports";

//헤더 -> 기업 탭 클릭 시 랜더링 되는 레이아웃
const CorpPage = () => {
  const [data, setData] = useState(null); //종목명 큐레이팅 데이터
  const [loading, setLoading] = useState(true);
  const [stockNews, setStockNews] = useState([]);
  const [themeNews, setThemeNews] = useState([]);

  const getStockData = () => {
    //상위 10개 종목 중 랜덤 노출
    getStockcode()
      .then((code) => code)
      .then((code) =>
        getStockDataAPI(code)
          .then((res) => {
            setData(res);
            return res;
          })
          .then((res) => {
            getRealtimeNewsAPI().then((res) => setStockNews(res));
            getIndustryNThemeNewsAPI("industry", res.FICS_sub).then((res) => {
              setThemeNews(res);
              setLoading(false);
            });
          })
      );
  };

  useEffect(() => {
    getStockcode2()
      .then((res) => {
        setData(res);
        return res;
      })
      .then((data) => {
        console.log("data", data);
        getRealtimeNewsAPI({ stockcode: data?.stockcode }).then((res) => {
          console.log("res", res);
          setStockNews(res);
        });
        getIndustryNThemeNewsAPI("industry", data?.FICS_sub).then((res) => {
          setThemeNews(res);

          setLoading(false);
        });
      });
  }, []);

  return (
    <div className="container">
      <div className="stock inner_container">
        {data && (
          <>
            <StockSummary stock={data} />
            {loading ? (
              <Loading />
            ) : (
              <>
                <div className="stock_news_container">
                  <p className="title_sm">{data?.stockname} 뉴스</p>
                  <NewsList newsList={stockNews} type="vertical" size="5" />
                </div>
                <NineMemosReports stockcode={data?.stockcode} />
                <div className="theme_news_container">
                  <p className="title_sm">관련 산업과 테마 뉴스</p>
                  <NewsList newsList={themeNews} type="vertical" size="5" />
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CorpPage;
